import { qs } from '@fluorescent/dom';

export default function PredictiveSearch(resultsContainer) {
  const settings = qs('[data-search-settings]', document);
  const { limit, show_articles, show_pages } = JSON.parse(settings.innerHTML);
  // TODO the following lines are causing a javascript in Safari because it doesn't support
  // regex lookbehind. Find a real fix at a later point. For now we are disabling
  // highLightQuery()
  // const regexHeadings =
  //   /(?<=<div class="quick-search__result-heading">)(.*?)(?=<\/div>)/g;
  // const regexVendors =
  //   /(?<=<span class="quick-search__result-vendor">)(.*?)(?=<\/span>)/g;

  const cachedResults = {};

  let types = 'product';

  if (show_articles) {
    types += ',article';
  }

  if (show_pages) {
    types += ',page';
  }

  function renderSearchResults(resultsMarkup) {
    resultsContainer.innerHTML = resultsMarkup;
  }

  function highLightQuery(searchTerm, searchResult) {
    let highLightedResult = searchResult;

    const regex = new RegExp('(' + searchTerm + ')', 'gi');

    // Highlight all instances of query in headings
    highLightedResult = highLightedResult.replaceAll(regexHeadings, match => {
      return match.replace(regex, '<span class="hl">$1</span>');
    });

    // Highlight all instances of query in vendor -- specific to product results
    highLightedResult = highLightedResult.replaceAll(regexVendors, match => {
      return match.replace(regex, '<span class="hl">$1</span>');
    });

    return highLightedResult;
  }

  function getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (cachedResults[queryKey]) {
      renderSearchResults(cachedResults[queryKey]);
      return;
    }

    fetch(
      `${window.theme.routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&${encodeURIComponent('resources[type]')}=${types}&${encodeURIComponent(
        'resources[limit]'
      )}=${limit}&section_id=predictive-search`
    )
      .then(response => {
        if (!response.ok) {
          const error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then(text => {
        let resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        // Highlight anything queried
        // resultsMarkup = highLightQuery(searchTerm, resultsMarkup);

        // Cache results
        cachedResults[queryKey] = resultsMarkup;
        renderSearchResults(resultsMarkup);
      })
      .catch(error => {
        throw error;
      });
  }

  return { getSearchResults };
}
